import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../../navigations/RootNavigation";
import Text from "../../../components/Text";
import { useIsScreenSizeMin } from "../../../hooks/useIsScreenSizeMin";
import { LargeLayout } from "./components/LargeLayout";
import { SmallLayout } from "./components/SmallLayout";

export type WelcomeScreenProps = StackScreenProps<RootStackParamList, "Welcome">;

const WelcomeScreen = (props: WelcomeScreenProps) => {
    const isLarge = useIsScreenSizeMin("large");

    return isLarge ? <LargeLayout {...props} /> : <SmallLayout {...props} />;
};

export default WelcomeScreen;
